export const superAdmin = "SuperAdmin";
export const restaurantAdmin = "RestaurantAdmin";
export const restaurantOperator = "RestaurantOperator";